import { Modal } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useRef, useState } from "react";
import { FaDownload } from "react-icons/fa6";
import { PiCertificateBold } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // ADDED

import RequestQuizModal from "../../../QuizStudio/component/common/RequestQuizModal";
import datacodeImg from "../../../../../src/assets/images/datacode_certificatre_logo.png";
import { getCandidateReviewReport } from "../../../QuizStudio/actions";
import { technologyIcon } from "../assessment/technologyIcon";
import Button from "../../../ReusableComponent/Button";
import Badge from "../../../ReusableComponent/Badge";

const AssessmentCard = ({ quizTestsList }) => {
  const certificateRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ADDED
  const { candidateReportReviewDetails } = useSelector(
    (state) => state.quizTest
  );

  const [certificateModal, setCertificateModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showCertificate, setShowCertificate] = useState(false);
  const [availableAssessments, setAvailableAssessments] = useState([]);

  const currentUser = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    if (quizTestsList) {
      const filteredTests = quizTestsList.filter(
        (item) =>
          item.quizCategory?.toLowerCase() === "assessment" &&
          item.isAttempted === true
      );

      setAvailableAssessments(filteredTests);
    }
  }, [quizTestsList]);

  // ADDED: Start quiz again
  const startQuizAgain = (item) => {
    navigate(`/assessments/${item._id}`);
  };

  // ADDED: Button handling logic
  const renderActionButton = (item) => {
    // CASE 1: PUBLIC + PASSED → No button
    if (item.access === "public" && item.isPassed) {
      return null;
    }

    // CASE 2: PUBLIC + FAILED → Try Again
    if (item.access === "public" && !item.isPassed) {
      return (
        <Button
          // variant="gradient"
          size="sm"
          onClick={() => startQuizAgain(item)}
        >
          Try Again
        </Button>
      );
    }

    // CASE 3 & 4:
    // INVITE + FAILED
    // OR INVITE + EXPIRED + INVITED
    if (
      item.access === "invite" &&
      (!item.isPassed ||
        (item.inviteStatus === "expired" && item.invited === true))
    ) {
      return (
        <Button>
          <RequestQuizModal label="Request Quiz" quizTitle={item.quizTitle} />
        </Button>
      );
    }

    return null;
  };

  const downloadCertificate = async () => {
    const certificateElement = certificateRef.current;
    if (certificateElement) {
      const canvas = await html2canvas(certificateElement, {
        scale: 2,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth =
        canvas.width > canvas.height
          ? pdfWidth
          : (pdfWidth / canvas.height) * canvas.width;

      const imgHeight =
        canvas.width > canvas.height
          ? (pdfHeight / canvas.width) * canvas.height
          : pdfHeight;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      pdf.save("certificate.pdf");
    }
  };

  const openCertificateModal = (item) => {
    setCertificateModal(true);
    setShowCertificate(false);
    setProgress(0);
    dispatch(getCandidateReviewReport(item)).then(() => {
      console.log(candidateReportReviewDetails, "details");
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setShowCertificate(true);
            return 100;
          }
          return prev + 10;
        });
      }, 100);
    });
  };

  return (
    <>
      <div className="row mx-0 d-flex justify-content-center align-items-center">
        <div className="col-12 mx-0">
          <h2 className="py-3 fs-5">Previously Taken Tests</h2>
          <div className="row mx-0">
            {availableAssessments.length > 0 ? (
              availableAssessments.map((item, index) => {
                const quizTechnology = item?.quizTechnology.toLowerCase();
                const iconUrl = technologyIcon.find(
                  (item) =>
                    item?.technologyName.toLowerCase() === quizTechnology
                );
                return (
                  <div className="col-12 col-md-4 px-0">
                    <div key={index} className="Assessment-card-manage mt-3 ">
                      <div className="card m-lg-2">
                        <div className="card-body">
                          <div className="d-flex justify-content-start align-items-start w-100">
                            <img
                              src={
                                iconUrl?.technologyIconImageUrl
                                  ? iconUrl?.technologyIconImageUrl
                                  : "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg"
                              }
                              alt="..."
                              height={50}
                              width={50}
                              className="me-3"
                            />
                            <div className="d-flex flex-column m-0 p-0 w-100">
                              <div className="d-flex justify-content-between">
                                <h2 className="fs-md-16 fs-16 mb-0 text-capitalize ">
                                  {item?.quizTitle}
                                </h2>
                                <span>
                                  <button
                                    className={`btn ms-2 fs-16 text-white fw-bold`}
                                    style={{
                                      backgroundColor: item?.isPassed
                                        ? "#4CAF72"
                                        : "#E05D5D",
                                      border: "none",
                                      opacity: 1,
                                      filter: "brightness(110%)",
                                      pointerEvents: "none",
                                    }}
                                    disabled
                                  >
                                    {item?.isPassed ? "Pass" : "Fail"}
                                  </button>
                                </span>
                              </div>

                              <span className="mt-0 text-light fs-14">
                                <i className="bi bi-clock"></i> {item?.duration}{" "}
                                minutes
                              </span>
                              <span className="mt-0 text-light fs-14">
                                <i class="bi bi-question-square me-1"></i>
                                {item?.quizQuestions?.length} Questions
                              </span>
                            </div>
                          </div>
                          <div className="mt-2 d-flex justify-content-between align-items-center w-100">
                            <Badge
                              label={item?.access ? item.access : "Public"}
                              color="info"
                            />
{/* 
                            <button
                              className={`btn btn-outline-warning ${
                                item?.isPassed ? "text-white" : null
                              } `}
                              disabled={!item?.isPassed}
                              onClick={() => {
                                if (item.isPassed)
                                  openCertificateModal(item._id);
                              }}
                            >
                              <PiCertificateBold fontSize={25} />
                              Download Certificate
                            </button> */}
                            {item?.isPassed && (
                              <button
                                className="btn btn-outline-warning text-white"
                                onClick={() => openCertificateModal(item._id)}
                              >
                                Download Certificate
                              </button>
                            )}

                            {renderActionButton(item)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12 text-center mt-3">
                <p>No Previous Assessments available !!</p>
              </div>
            )}
          </div>
        </div>
      </div>
      {certificateModal && (
        <Modal
          width={850}
          open={certificateModal}
          title="Certificate"
          onCancel={() => setCertificateModal(false)}
          footer={[
            <button
              key="download"
              className="btn btn-success mx-2 vertical-align-middle"
              onClick={downloadCertificate}
              disabled={!showCertificate}
            >
              <span className="d-flex align-items-center">
                <FaDownload className="me-2" />
                <span>Download Certificate</span>
              </span>
            </button>,
            <button
              key="close"
              className="btn btn-primary"
              onClick={() => setCertificateModal(false)}
            >
              Close
            </button>,
          ]}
        >
          {!showCertificate ? (
            <div className="text-center">
              <p>Loading certificate...</p>
              <div
                style={{
                  margin: "20px auto",
                  width: "80%",
                  height: "20px",
                  borderRadius: "10px",
                  background: "rgba(200, 200, 200, 0.4)",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${progress}%`,
                    background: "linear-gradient(90deg, #6a11cb, #2575fc)",
                    borderRadius: "10px",
                    transition: "width 0.2s ease",
                  }}
                />
              </div>
              <span>{progress}%</span>
            </div>
          ) : (
            <div ref={certificateRef} className="row mx-0 border">
              <div className="col-12 px-0">
                <div className="row mx-0 w-100 h-100 datacode-certificate">
                  <div className="col-12 col-md-7 px-3 px-md-5">
                    <img
                      src={datacodeImg}
                      alt="Datacode logo"
                      className="my-4 my-md-5 mx-0 w-100 object-fit-cover"
                      height="100px"
                    />
                    <p className="mt-4 mt-md-5 mb-0 sub-title">
                      This certificate is presented to:
                    </p>
                  </div>
                  <div className="col-12 col-md-9 px-3 px-md-5">
                    <h1 className="pt-3 pt-md-0">
                      {currentUser?.firstName + " " + currentUser?.lastName ||
                        "Student Name"}
                    </h1>
                    <p className="mb-4 mb-md-5 description">
                      Assessment Completed, Success Achieved!
                      <br />
                      Congratulations on Your Well-Deserved Success!
                    </p>
                    <div className="my-4 my-md-5 pt-4 pt-md-5">
                      <span className="oragnised">ASSESSMENT ORGANIZED BY</span>
                      <br />
                      <span className="host">DATACODE COMMUNITY</span>
                    </div>
                    <span className="text-secondary">
                      Certificate Id : {candidateReportReviewDetails?._id}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default AssessmentCard;
